import React, { useEffect, useState } from 'react'
import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import { useBoolean } from "@fluentui/react-hooks";
import TokenService from '../../../services/Authentication/TokenService';
import { urlTelerik } from '../../../services/http-common';
import themeBase from '../../../utils/theme/themeBase';
import { IExportarReporte } from '../../../Interfaces/base/IBase';
import reporteServicio from '../../../services/reporteService';
import IconHelper from '../../../utils/helpers/iconHelper';
import { ComboBox, CommandBar, DatePicker, FontSizes, IComboBoxOption, IComboBoxProps, IComboBoxStyles, ICommandBarItemProps, ITextProps, PanelType, defaultDatePickerStrings } from '@fluentui/react';
import { PanelGenerico } from '../../../components/generic/PanelGenerico';
import { formatDateStr_DDMMYY, formatDate_DDMMYY } from '../../../utils/helpers/dateHelpers';
import COLORES from '../../../utils/theme/colores';
import { Text } from '@fluentui/react/lib/Text';
import { color } from 'd3';
import Estado from '../../../components/elements/Estado';

export interface IRankingSupervisor {
    // isOpen: boolean;
    // onDismiss: () => void;
    reportName: string,
    parametros: {} | undefined,
    formatos?: number,
    viewMode?: string
    // reload: () => void;
}

export interface IParametrosRanking {
    Fecha: string,
    Estado: string,
    Documento: string
}

export interface IParametro {
    Key: string;
    Value: string;
}
const comboBoxStyles: Partial<IComboBoxStyles> = { root: { maxWidth: 800 } };

export const RankingSupervisor = (props: IRankingSupervisor) => {
    const { reportName, parametros, formatos = 1, viewMode } = props; // Asignar valor por defecto directamente aquí
    const [currentFormatos, setCurrentFormatos] = useState(formatos);
    const [currentViewMode, setViewMode] = useState(viewMode);

    const dateDefault = new Date();
    const firstDayOfMonth = new Date(dateDefault.getFullYear(), dateDefault.getMonth(), 1);

    const [fechaInicio, setFechaInicio] = useState<Date>(firstDayOfMonth);

    const optionsEstado: IComboBoxOption[] = [
        { key: 'Verificados', text: 'Verificados' },
        { key: 'Pendientes', text: 'Pendientes' },
    ];

    const [selectedKeyEstado, setSelectedKeyEstado] = React.useState<string>('Verificados');
    const onChange: IComboBoxProps['onChange'] = (event, option) => setSelectedKeyEstado(option!.key as string);


    const optionsDocumento: IComboBoxOption[] = [
        { key: 'IPERC', text: 'IPERC' },
        { key: 'Checklist', text: 'Checklist' },
    ];

    const [selectedKeyDocumento, setSelectedKeyDocumento] = React.useState<string>('IPERC');
    const onChangeDocumento: IComboBoxProps['onChange'] = (event, option) => setSelectedKeyDocumento(option!.key as string);

    const [filtroRanking, setFiltroRanking] = useState<IParametrosRanking>(
        {
            Fecha: fechaInicio.toISOString(),
            Estado: "Verificados",
            Documento: "IPERC"
        });

    const [
        isOpenPanelFiltro,
        { setTrue: openPanelFiltro, setFalse: dismissPanelFiltro },
    ] = useBoolean(false);

    useEffect(() => {
        // Actualizar el estado si el prop 'formatos' cambia
        setCurrentFormatos(formatos);
    }, [formatos]);
    useEffect(() => {
        // Actualizar el estado si el prop 'formatos' cambia
        setViewMode(viewMode);
    }, [viewMode]);

    // useEffect(() => {
    //     console.log("Formatos:", currentFormatos);
    // }, [currentFormatos]);

    let t = TokenService.getToken();
    let viewerRef;
    const urlTelerikR = `${urlTelerik}/reports`;

    const [key, setKey] = useState(0);

    const viewerOptions = {
        serviceUrl: urlTelerikR,
        reportSource: {
            report: props.reportName,
            parametros: props.parametros
            //parameters: { "editors": { "multiSelect": { "listaVerificacionId": "50884d84-fd34-43ff-9686-179542b5a7aa" } } },
        },
        viewerContainerStyle: themeBase.telerikStyle,
        // viewerContainerStyle: viewerContainerStyle,
        // viewMode: currentViewMode,
        // viewMode: 'Interactive',
        viewMode: 'PRINT_PREVIEW',
        scaleMode: 'FIT_PAGE_WIDTH',
        // scaleMode: 'SPECIFIC',
        scale: 1.0,
        enableAccessibility: false,
        toolbar: {
            items: [
                {
                    type: 'togglePrintPreview',
                    text: 'Print',
                    visible: true
                },
                {
                    type: 'export',
                    text: 'Export',
                    visible: false
                }
            ]
        },
        authenticationToken: t,
        // ready: function () {
        //   //this.refreshReport();
        // }

    };

    const transformarParametros = (parametros: IParametrosRanking): IParametro[] => {
        return Object.entries(parametros).map(([key, value]) => ({
            Key: key,
            Value: value,
        }));
    };

    function descargarReporte(extension: string) {
        const reporteExportar: IExportarReporte = {
            report: props.reportName,
            Extension: extension,
            //Parametros: [{ filtroRanking }]
        }
        reporteExportar.Parametros = transformarParametros(filtroRanking);

        reporteServicio.exportaReporte(reporteExportar)
            .then((response) => {
                if (response.status === 200) {
                    // response.json().then((data) => {
                    //   console.log("Datos de la respuesta:", data);
                    // });
                    //   console.log("Datos de la respuesta: Reporte generado ----");
                    //   console.log(response.data);

                    const dataUrl = response.data;

                    // Create a link element
                    const link = document.createElement('a');
                    link.href = dataUrl;
                    link.download = 'reporte'; // Puedes obtener el nombre del archivo de la respuesta si está disponible

                    // Simulate a click on the link to trigger the download
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                }
                else {
                    console.error("Status:", response.status);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    // Función para recargar el componente
    const recargarComponente = () => {
        setKey(prevKey => prevKey + 1);
    };

    const _items: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_RELOAD,
            // onClick: (arg) => actualizarTabla(),
            // onClick: () => viewerRef.refreshReport(),
            onClick: recargarComponente,
        }
    ];

    const getFarItems = () => {
        if (currentFormatos === 1) {
            return [
                {
                    ...IconHelper.ICON_PDF,
                    onClick: () => {
                        descargarReporte("PDF");
                    },
                },
                {
                    ...IconHelper.ICON_FILTER,
                    onClick: () => {
                        openPanelFiltro();
                    },
                }
            ];
        } else if (currentFormatos === 2) {
            return [
                {
                    ...IconHelper.ICON_PDF,
                    onClick: () => {
                        descargarReporte("PDF");
                    },
                },
                {
                    ...IconHelper.ICON_EXCEL,
                    onClick: () => {
                        descargarReporte("XLSX");
                    },
                },
                {
                    ...IconHelper.ICON_FILTER,
                    onClick: () => {
                        openPanelFiltro();
                    },
                }
            ];
        } else {
            return [];
        }
    };

    const _farItems: ICommandBarItemProps[] = getFarItems();

    useEffect(() => {
        const hideExportButton = () => {
            const exportButton: any = document.querySelector("#trv-main-menu-export-command");
            // console.log(exportButton)

            if (exportButton) {
                // console.log(exportButton)
                exportButton.remove();
                // exportButton.style.display = 'none';
                clearInterval(interval);
            }
        };

        // Usa un intervalo para asegurar que el botón sea encontrado y ocultado
        const interval = setInterval(hideExportButton, 1);

        // Limpia el intervalo al desmontar el componente
        return () => clearInterval(interval);
    }, [key]);


    useEffect(() => {
        // Actualizar el estado si el prop 'formatos' cambia
        // recargarComponente();
        viewerRef.refreshReport()
    }, [props.reportName]);

    const _back = () => {
        setFiltroRanking({
            ...filtroRanking,
            Fecha: firstDayOfMonth.toISOString(),
            Estado: 'Verificados',
            Documento: 'IPERC'
        })
        setFechaInicio(firstDayOfMonth)
        setKey(prevKey => prevKey + 1);
        dismissPanelFiltro();
    };

    const _closePanel = () => {
        dismissPanelFiltro();
    };

    const changeFilter = () => {
        setFiltroRanking({
            ...filtroRanking,
            Fecha: fechaInicio.toISOString(),
            Estado: selectedKeyEstado,
            Documento: selectedKeyDocumento,
        })
        setKey(prevKey => prevKey + 1);
        dismissPanelFiltro()
    };

    const renderFiltro = () => {
        const listFiltrosRender = transformarParametros(filtroRanking);
        if (listFiltrosRender.length > 0) {
            return (
                <div>
                    {/* {listFiltrosRender.map((setting, index) => (
                        <div key={setting.Key + index} style={{ marginBottom: '10px' }}>
                            <Text variant={setting.Key as ITextProps['variant']} nowrap block>
                                {setting.Key}: {index}
                            </Text>
                        </div>
                    ))} */}

                    {listFiltrosRender.map((setting, index) => (
                        <div key={index}
                            // style={{ marginBottom: '10px' }}
                            style={{ fontSize: FontSizes.size10 }}
                        >
                            <Text
                                style={{ fontSize: FontSizes.size10, color: '#626264' }}
                            // nowrap block
                            >
                                <span style={{ marginRight: '8px' }}>✓</span>
                                {setting.Key === 'Fecha'
                                    ? `${setting.Key}: ${formatDateStr_DDMMYY(setting.Value)}`
                                    : `${setting.Key}: ${setting.Value}`}
                            </Text>
                        </div>
                    ))}
                </div>
            )
        }
        else {
            return (<>
                <div style={{ marginBottom: '10px' }}>
                    <Text nowrap block>
                        No hay filtros aplicados.
                    </Text>
                </div>
            </>)
        }

    }

    return (
        <>
            {/* <pre>{JSON.stringify("--------filtroRanking---", null, 2)}</pre>
            <pre>{JSON.stringify(filtroRanking, null, 2)}</pre> */}
            {/* <pre>{JSON.stringify("--------Date---", null, 2)}</pre>
            <pre>{JSON.stringify(dateDefault, null, 2)}</pre>
            <pre>{JSON.stringify(fechaInicio, null, 2)}</pre> */}

            <div className="ms-Grid-col ms-sm12 ms-lg12">
                <CommandBar
                    items={_items}
                    farItems={_farItems}
                    styles={themeBase.commadStyles}
                />
            </div>
            <PanelGenerico
                HeaderTitlesText={
                    {
                        title: "Filtros",

                        //subTitle2: `Filto aplicado: ${formatDateStr_DDMMYY(filtroRanking.Fecha)}`
                    }}
                enabledHeader
                isOpen={isOpenPanelFiltro}
                onDismiss={_closePanel}
                panelType={PanelType.smallFixedFar}
                cancelar={_back}
                //objectRenderBodyHelp={{ ...form, val: equal }}
                //disabledRegister={disableForm}
                textRegister='Filtrar'
                textCancel='Limpiar filtro'
                registrar={changeFilter}
            >
                {/* <pre>{JSON.stringify(selectedKeyEstado, null, 2)}</pre> */}
                <div>
                    {renderFiltro()}

                    <br />
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg9">
                        <DatePicker
                            label="Fecha:"
                            placeholder="dd/mm/yyyy"
                            ariaLabel="Seleccione una fecha"
                            // onSelectDate={setFechaInicio as (date?: any) => void}
                            onSelectDate={setFechaInicio as (date?: any) => void}
                            formatDate={formatDate_DDMMYY}
                            strings={defaultDatePickerStrings}
                            value={fechaInicio}
                            maxDate={new Date()}
                            borderless
                            style={{ borderBottom: `solid 1px ${COLORES.Bases.primary}` }}
                        />
                    </div>
                    <br />
                    <ComboBox
                        //defaultSelectedKey="Verificados"
                        label="Seleccione un estado"
                        onChange={onChange}
                        options={optionsEstado}
                        placeholder={selectedKeyEstado}


                    //styles={comboBoxStyles}
                    //calloutProps={{ doNotLayer: true }}
                    />
                    <br />
                    <ComboBox
                        // defaultSelectedKey="IPERC"
                        label="Seleccione un documento"
                        onChange={onChangeDocumento}
                        options={optionsDocumento}
                        placeholder={selectedKeyDocumento}


                    //styles={comboBoxStyles}
                    //calloutProps={{ doNotLayer: true }}
                    />
                </div>
            </PanelGenerico>

            <div key={key}
                style={{
                    // border: '5px solid red',
                    width: '100%',
                    height: 'auto'
                }}
            >
                <TelerikReportViewer
                    ref={el => viewerRef = el}
                    serviceUrl={viewerOptions.serviceUrl}
                    reportSource={{
                        report: viewerOptions.reportSource.report,
                        parameters: filtroRanking
                    }}
                    //viewerContainerStyle={viewerOptions.viewerContainerStyle}
                    viewerContainerStyle={viewerOptions.viewerContainerStyle}
                    parametersAreaVisible={true}
                    viewMode={viewerOptions.viewMode}
                    scaleMode={viewerOptions.scaleMode}
                    scale={viewerOptions.scale}
                    enableAccessibility={viewerOptions.enableAccessibility}
                    authenticationToken={viewerOptions.authenticationToken}
                    toolbarItems={viewerOptions.toolbar.items}
                    skipBlankPages={false}
                />
            </div>
        </>
    )
}
